import Vue from 'vue';
import Vuex from 'vuex';
import {performance} from './stores/Performance';
import {settings, applySettingsAtLoad} from './stores/Settings';
import {analytics, collectAnalyticsAtLoad} from '@/stores/Analytics';
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const store =  new Vuex.Store({
    modules: {
        performance,
        settings,
        analytics
    },
    plugins: [
        // Persist contents of the settings module between sessions
        // Using vuex-persistedstate package
        createPersistedState({
            paths: ['settings'],
            // If there are problems with settings being applied on load,
            // the following line may need to be reactivated
            // rehydrated: applySettingsAtLoad
        }),
        // Apply settings after the store has been loaded
        applySettingsAtLoad,
        collectAnalyticsAtLoad
    ]
});

export default store;
